import { Outlet } from 'react-router-dom';
import { Paper, useMantineColorScheme } from '@mantine/core';

import { Sidebar } from '../sidebar';
import classes from './root.module.css';
import { SkyElements } from './SkyElements';

export function DashboardLayout() {
  const { colorScheme } = useMantineColorScheme();

  return (
    <div className={classes.root}>
      <Paper 
        className={classes.sidebarWrapper} 
        withBorder
        bg="transparent"
        c={colorScheme === 'dark' || colorScheme === 'auto' ? 'white' : 'black'}
        style={{ 
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)'
        }}
      >
        <Sidebar />
      </Paper>
      <main className={classes.content}>
        <SkyElements />
        <Outlet />
      </main>
    </div>
  );
}
